import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _obj;
/* import __COLOCATED_TEMPLATE__ from './bread-crumbs.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { filter } from "@ember/object/computed";
import deprecated from "discourse-common/lib/deprecated";
import discourseComputed from "discourse-common/utils/decorators";

//  A breadcrumb including category drop downs
import TEMPLATE from "./bread-crumbs.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend((_dec = discourseComputed("category", "categories", "noSubcategories"), _dec2 = discourseComputed("siteSettings.tagging_enabled", "editingCategory"), _dec3 = discourseComputed("category"), _dec4 = discourseComputed("parentCategories"), _dec5 = discourseComputed("category"), _dec6 = discourseComputed("category", "parentCategory"), _dec7 = discourseComputed("category", "parentCategory"), _dec8 = discourseComputed("firstCategory", "hideSubcategories"), (_obj = {
  classNameBindings: ["hidden:hidden", ":category-breadcrumb"],
  tagName: "ol",
  editingCategory: false,
  editingCategoryTab: null,
  categoryBreadcrumbs(category, filteredCategories, noSubcategories) {
    const ancestors = category?.ancestors || [];
    const parentCategories = [undefined, ...ancestors];
    const categories = [...ancestors, undefined];
    return parentCategories.map((x, i) => [x, categories[i]]).map(record => {
      const [parentCategory, subCategory] = record;
      const options = filteredCategories.filter(c => c.get("parentCategory.id") === (parentCategory && parentCategory.id));
      return {
        category: subCategory,
        parentCategory,
        options,
        isSubcategory: !!parentCategory,
        noSubcategories: !subCategory && noSubcategories,
        hasOptions: !parentCategory || parentCategory.has_children
      };
    });
  },
  showTagsSection(taggingEnabled, editingCategory) {
    return taggingEnabled && !editingCategory;
  },
  parentCategory(category) {
    deprecated("The parentCategory property of the bread-crumbs component is deprecated", {
      id: "discourse.breadcrumbs.parentCategory"
    });
    return category && category.parentCategory;
  },
  parentCategories: filter("categories", function (c) {
    deprecated("The parentCategories property of the bread-crumbs component is deprecated", {
      id: "discourse.breadcrumbs.parentCategories"
    });
    if (c.id === this.site.get("uncategorized_category_id") && !this.siteSettings.allow_uncategorized_topics) {
      // Don't show "uncategorized" if allow_uncategorized_topics setting is false.
      return false;
    }
    return !c.get("parentCategory");
  }),
  parentCategoriesSorted(parentCategories) {
    deprecated("The parentCategoriesSorted property of the bread-crumbs component is deprecated", {
      id: "discourse.breadcrumbs.parentCategoriesSorted"
    });
    if (this.siteSettings.fixed_category_positions) {
      return parentCategories;
    }
    return parentCategories.sortBy("totalTopicCount").reverse();
  },
  hidden(category) {
    return this.site.mobileView && !category;
  },
  firstCategory(category, parentCategory) {
    deprecated("The firstCategory property of the bread-crumbs component is deprecated", {
      id: "discourse.breadcrumbs.firstCategory"
    });
    return parentCategory || category;
  },
  secondCategory(category, parentCategory) {
    deprecated("The secondCategory property of the bread-crumbs component is deprecated", {
      id: "discourse.breadcrumbs.secondCategory"
    });
    return parentCategory && category;
  },
  childCategories(firstCategory, hideSubcategories) {
    deprecated("The childCategories property of the bread-crumbs component is deprecated", {
      id: "discourse.breadcrumbs.childCategories"
    });
    if (hideSubcategories) {
      return [];
    }
    if (!firstCategory) {
      return [];
    }
    return this.categories.filter(c => c.get("parentCategory") === firstCategory);
  }
}, (_applyDecoratedDescriptor(_obj, "categoryBreadcrumbs", [_dec], Object.getOwnPropertyDescriptor(_obj, "categoryBreadcrumbs"), _obj), _applyDecoratedDescriptor(_obj, "showTagsSection", [_dec2], Object.getOwnPropertyDescriptor(_obj, "showTagsSection"), _obj), _applyDecoratedDescriptor(_obj, "parentCategory", [_dec3], Object.getOwnPropertyDescriptor(_obj, "parentCategory"), _obj), _applyDecoratedDescriptor(_obj, "parentCategoriesSorted", [_dec4], Object.getOwnPropertyDescriptor(_obj, "parentCategoriesSorted"), _obj), _applyDecoratedDescriptor(_obj, "hidden", [_dec5], Object.getOwnPropertyDescriptor(_obj, "hidden"), _obj), _applyDecoratedDescriptor(_obj, "firstCategory", [_dec6], Object.getOwnPropertyDescriptor(_obj, "firstCategory"), _obj), _applyDecoratedDescriptor(_obj, "secondCategory", [_dec7], Object.getOwnPropertyDescriptor(_obj, "secondCategory"), _obj), _applyDecoratedDescriptor(_obj, "childCategories", [_dec8], Object.getOwnPropertyDescriptor(_obj, "childCategories"), _obj)), _obj))));